




























import { Vue, Component, Prop } from 'vue-property-decorator'
import ScaleView from 'components/ScaleView.vue'
import SlideView from 'components/presenter/item/topic/viewer/View.vue'
import { SlideParamsValuesSet } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    ScaleView,
    SlideView
  }
})
export default class AttendeeResponseViewer extends Vue {

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly seed!: string | undefined

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  @Prop()
  readonly value!: { [key: string]: boolean | string } | string | string[] | number | number[] | undefined

  @Prop({ default: false })
  readonly disabled!: boolean
}
